import { Linkable } from "@/components/elements/Linkable";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TLoginPageProps = {};

export const LoginPage: FC<TLoginPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <LoginForm />
      <Linkable href={AppRoutes.recover}>
        <Typography variant="body14" color={text.link}>
          パスワードを忘れた方はこちら
        </Typography>
      </Linkable>
    </Stack>
  );
};
